import CHART_TYPES from '../../charts'

import moment from 'moment'

export default {
  reportingCtctOverview: {
    charts: [
      {
        className: 'grid-col-12',
        type: CHART_TYPES.CARD,
        title:
          'These stats are updated every night at 00:00AM UTC time. The stats below show data for only Constant Contact'
      },
      {
        title: 'Joins',
        type: CHART_TYPES.TINY,
        name: 'joins',
        tooltip: [
          'Number of newly created accounts on/in <date end>',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'New Hosting Units',
        type: CHART_TYPES.TINY,
        name: 'newHostingUnits',
        tooltip: [
          'Number of newly bought plans on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'Join Conversion',
        type: CHART_TYPES.TINY,
        name: 'joinConversion',
        suffix: '%',
        tooltip: [
          'Percentage of newly bought plans relative to newly created accounts on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'Cancels',
        type: CHART_TYPES.TINY,
        name: 'cancels',
        tooltip: [
          'Number of cancelled plans on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'Total Revenue',
        type: CHART_TYPES.TINY,
        name: 'totalUnitRevenue',
        prefix: '$',
        tooltip: [
          'Total revenue in $ on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'New Revenue',
        type: CHART_TYPES.TINY,
        name: 'totalNewRevenue',
        prefix: '$',
        tooltip: [
          'New revenue (Hosting cash + Addon cash) in $ on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'Earned Cash',
        type: CHART_TYPES.AREA,
        name: 'earnedCash',
        yAxis: 'Amount',
        tooltip:
          'A visual representation of the table above on specific dates (or periods if grouped on week, month or year), showing the New/Rebill Hosting and the New/Rebill Addon amount together with the Refund.',
        prefix: '$'
      },
      {
        title: 'Join Conversion for selected brands',
        type: CHART_TYPES.GRAPH,
        name: 'joinConversionPerBrand',
        doubleYAxis: true,
        suffix: '%',
        yAxis: ['Conversion', 'Joins'],
        visible: ['Total Conversion', 'Total Joins', 'ConstantContact Joins', 'ConstantContact Conversion'],
        disableBrands: true,
        tooltip: [
          'A visual representation of the join conversion on specific dates (or periods if grouped on week, month or year).',
          'By default Total Conversion and Total Joins is enabled and shown, and you can (de)select specific brands to compare results on brand level.'
        ]
      },
      {
        title: 'New Hosting units by term',
        type: CHART_TYPES.FIXED,
        name: 'newHostingUnitsTerms',
        valueName: 'Units',
        yAxis: 'Percentage',
        tooltip:
          'A visual representation of the percentage of the terms chosen for newly bought plans on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'New subscription units',
        type: CHART_TYPES.GRAPH,
        name: 'newSubscriptionUnits',
        hideSeries: ['All Brands'],
        emptyScreenWhenNoData: true,
        disableBrands: true,
        tooltip:
          'A visual representation of the number of newly bought plans on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'New subscription revenue per day',
        type: CHART_TYPES.GRAPH,
        name: 'newSubscriptionRevenue',
        hideSeries: ['All Brands'],
        emptyScreenWhenNoData: true,
        disableBrands: true,
        prefix: '$',
        tooltip:
          'A visual representation of the revenue for newly bought plans on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'New addon units',
        type: CHART_TYPES.STACKED,
        name: 'newUpsellUnits',
        disableBrands: true,
        tooltipLabel: 'sales',
        tooltip:
          'A visual representation of the number of newly bought addons on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'New addon revenue',
        type: CHART_TYPES.STACKED,
        name: 'newUpsellRevenue',
        disableBrands: true,
        prefix: '$',
        tooltipLabel: ' ',
        tooltip:
          'A visual representation of the revenue of newly bought addons on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'New Units for selected plans',
        type: CHART_TYPES.GRAPH,
        name: 'plansNewUnits',
        yAxis: 'Amount per plan',
        tooltip: [
          'A visual representation of the number of newly bought plans per plan type on specific dates (or periods if grouped on week, month or year).',
          'GATOR plans: Starter (PLAN1), Premium (PLAN3), Ecommerce (PLAN4).'
        ]
      },
      {
        title: 'Hosting renewals in plan codes',
        type: CHART_TYPES.GRAPH,
        name: 'rebillPlans',
        yAxis: 'Amount per plan',
        tooltip: [
          'A visual representation of the number of renewed plans per plan type on specific dates (or periods if grouped on week, month or year).',
          'GATOR plans: Starter (PLAN1), Premium (PLAN3), Ecommerce (PLAN4).'
        ]
      },
      {
        title: 'New Hosting payment type units',
        type: CHART_TYPES.GRAPH,
        name: 'newHostingPaymentType',
        yAxis: 'Amount per payment type',
        tooltip:
          'A visual representation of the number of Credit Card and PayPal payments of newly bought plans per plan type on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'Month-to-Date comparison',
        type: CHART_TYPES.TABLE,
        name: 'MonthToDateComparison',
        fixedNumbers: true,
        tooltip:
          'Detailed table of the 6 most important Month-to-Date Financial Stats, compared to that same date range for the 2 previous months and that same date range for exactly 1 year ago.',
        className: 'grid-col-6'
      }
    ],
    sourcedatabase: 'reportinggator',
    route: '/financial-reports/ctct/overview',
    disableToday: true,
    fixedPartnerId: 50
  },
  reportingCtctSales: {
    charts: [
      {
        className: 'grid-col-12',
        type: CHART_TYPES.CARD,
        title:
          'These stats are updated every night at 00:00AM UTC time. The stats below show data for only Constant Contact'
      },
      {
        title: 'Sales Results',
        type: CHART_TYPES.TABLE,
        name: 'netResults',
        fixedNumbers: true,
        tooltip: [
          'Detailed table of the sales results on specific dates (or periods if grouped on week, month or year).',
          'New average hosting cash is calculated by dividing the New Hosting Cash through the New Hosting Units.',
          'Total Cash is New Cash + Renewal Cash - Refund Cash.',
          'Plan/Term Change Units / $ contains services that have been upgraded/downgraded and/or had a term change (these services are marked as such since 2019-02-04). Previously these services where part of New Hosting Units / $'
        ]
      },
      {
        title: 'Hosting',
        type: CHART_TYPES.TABLE,
        name: 'Hosting',
        fixedNumbers: true,
        tooltip: [
          'Detailed table of the sales results for hosting on specific dates (or periods if grouped on week, month or year).',
          'New average hosting cash is calculated by dividing the New Hosting Cash through the New Hosting Units.',
          'Upgrade Units / $ contains services that have been upgraded. Downgrade Units / $ contains services that have been downgraded. Term Change Units / $ contains services that had a term change (if they also had an upgrade/downgrade they are only shown in the upgrade/downgrade columns). These services are marked as such since 2019-02-04. Previously these services where part of New Hosting Units / $.'
        ]
      },
      {
        title: 'Addons',
        type: CHART_TYPES.TABLE,
        name: 'Addons',
        fixedNumbers: true,
        tooltip: [
          'Detailed table of the sales results for addons on specific dates (or periods if grouped on week, month or year).',
          'New average addon cash is calculated by dividing the New Addon Cash through the New Addon Units.'
        ]
      },
      {
        title: 'Coupon codes',
        type: CHART_TYPES.TABLE,
        name: 'CouponCodeDetails',
        sourcedatabase: 'appmarket'
      }
    ],
    sourcedatabase: 'reportinggator',
    route: '/financial-reports/ctct/sales',
    disableToday: true,
    fixedPartnerId: 50
  },
  reportingCtctTrafficSource: {
    charts: [
      {
        title: 'Joins',
        type: CHART_TYPES.TABLE,
        name: 'JoinsWithTracking'
      },
      {
        title: 'Transactions',
        type: CHART_TYPES.TABLE,
        name: 'TransactionsWithTracking'
      },
      {
        type: CHART_TYPES.TABLE,
        title: 'Traffic Source',
        name: 'SalesWithSource',
        sourcedatabase: 'reportinggator'
      },
      {
        title: 'Joins by Traffic source',
        type: CHART_TYPES.FIXED,
        name: 'AccountsBySource',
        tooltip: 'Displays the distribution of all joins by traffic source.'
      },
      {
        title: 'Plans by Traffic source',
        type: CHART_TYPES.FIXED,
        name: 'PlansByTrafficSource',
        tooltip:
          'Displays the distribution of the number of plans bought on Date X by the traffic source of the account of those plans.'
      }
    ],
    disableToday: true,
    route: '/financial-reports/ctct/traffic-source',
    fixedPartnerId: 50
  },
  reportingCtctFlashcash: {
    charts: [
      {
        className: 'grid-col-12',
        type: CHART_TYPES.CARD,
        title:
          'These stats are updated every night at 00:00AM UTC time. The stats below show data for only Constant Contact'
      },
      {
        title: 'Flash cash reports',
        type: CHART_TYPES.TABLE,
        name: 'flashcash',
        fixedNumbers: true,
        tooltip: [
          'Detailed table of the financial results on specific dates (or periods if grouped on week, month or year) split by brand.',
          'Data includes new, rebill, refund and cancellation information.'
        ]
      }
    ],
    sourcedatabase: 'reportinggator',
    route: '/financial-reports/ctct/flash',
    disableToday: true,
    fixedPartnerId: 50
  },
  reportingCtctToday: {
    charts: [
      {
        className: 'grid-col-20',
        type: CHART_TYPES.CARD,
        title: 'These stats are updated every hour. The stats below show data for only Constant Contact.'
      },
      {
        title: 'Joins',
        type: CHART_TYPES.CARD,
        name: 'todaysjoins',
        className: 'grid-col-4',
        tooltip: 'Todays number of newly created accounts.'
      },
      {
        title: 'New Hosting Units',
        type: CHART_TYPES.CARD,
        name: 'todaysnewhostingunits',
        className: 'grid-col-4',
        tooltip: 'Todays number of newly bought plans.'
      },
      {
        title: 'Join Conversion',
        type: CHART_TYPES.CARD,
        name: 'todaysjoinconversion',
        className: 'grid-col-4',
        suffix: '%',
        tooltip: 'Todays percentage of newly bought plans relative to newly created accounts.'
      },
      {
        title: 'Cancels',
        type: CHART_TYPES.CARD,
        name: 'todayscancels',
        className: 'grid-col-4',
        tooltip: 'Todays number of cancelled plans.'
      },
      {
        title: 'Total Revenue',
        type: CHART_TYPES.CARD,
        name: 'todaystotalrevenue',
        className: 'grid-col-4',
        prefix: '$',
        tooltip: 'Todays total revenue in $. Includes new Sales, Refunds, Renewals for both Hosting Units and Addons.'
      },
      {
        title: 'Sales / Renewals / Refunds',
        type: CHART_TYPES.PIE,
        name: 'todaysSalesRenewalsRefunds',
        tooltipLabel: 'items',
        customFormat: CHART_TYPES.PIE_WITH_PRICE,
        className: 'grid-col-4',
        tooltip: 'Todays ratio of new sales, renewals and refunds revenue.'
      },
      {
        title: 'Term distribution',
        type: CHART_TYPES.PIE,
        name: 'todaystermdistribution',
        tooltipLabel: 'sales',
        className: 'grid-col-4',
        tooltip: 'Todays ratio of the different terms for all new sales (Hosting and Addons; no Refunds/Renewals)'
      },
      {
        title: 'Upsell / subscription',
        type: CHART_TYPES.PIE,
        name: 'todaysupsellsubscriptiondistribution',
        tooltipLabel: 'sales',
        className: 'grid-col-4',
        tooltip: 'Todays ratio of Upsells (addons) and Subscriptions (plans) for all new sales (no Refunds/Renewals)'
      },
      {
        title: 'Service distribution',
        type: CHART_TYPES.PIE,
        name: 'todaysplandistribution',
        tooltipLabel: 'sales',
        className: 'grid-col-4',
        tooltip: [
          'Todays ratio of the different types of plans for all new sales (Hosting and Addons; no Refunds/Renewals)',
          'GATOR plans: Starter (PLAN1), Premium (PLAN3), Ecommerce (PLAN4).'
        ]
      },
      {
        title: 'Currency',
        type: CHART_TYPES.PIE,
        name: 'todayscurrency',
        tooltipLabel: 'sales',
        className: 'grid-col-4',
        tooltip:
          'Todays ratio of the different currency types for all new sales (Hosting and Addons; no Refunds/Renewals)'
      },
      {
        title: 'Todays transactions',
        type: CHART_TYPES.TABLE,
        name: 'todaystransactions',
        tooltip: [
          'Todays ratio of the different currency types for all new sales (no Refunds/Renewals)',
          'GATOR plans: Starter (PLAN1), Premium (PLAN3), Ecommerce (PLAN4).'
        ],
        className: 'grid-col-20',
        sorting: { default: { fieldNames: ['timestamp'], direction: false } },
        dontUseSourceDatabase: true,
        start: moment()
          .subtract(1, 'd')
          .format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    ],
    gridSize: 20,
    sourcedatabase: 'reportinggator',
    route: '/financial-reports/ctct/today',
    disableToday: true,
    hideDatePicker: true,
    fixedPartnerId: 50
  },
  reportingCtctAffiliates: {
    charts: [
      {
        className: 'grid-col-12',
        type: CHART_TYPES.CARD,
        title:
          'These stats are updated every night at 00:00AM UTC time and use Impact Radius data as source. The stats below show data for only Constant Contact'
      },
      {
        title: 'Joins',
        type: CHART_TYPES.TINY,
        name: 'joinsaffiliates',
        tooltip: [
          'Number of newly created accounts on/in <date end>',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'New Hosting Units',
        type: CHART_TYPES.TINY,
        name: 'newHostingUnitsaffiliates',
        tooltip: [
          'Number of newly bought plans on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'Join Conversion',
        type: CHART_TYPES.TINY,
        name: 'joinConversionaffiliates',
        suffix: '%',
        tooltip: [
          'Percentage of newly bought plans relative to newly created accounts on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'Cancels',
        type: CHART_TYPES.TINY,
        name: 'cancelsaffiliates',
        tooltip: [
          'Number of cancelled plans on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'Total Revenue',
        type: CHART_TYPES.TINY,
        name: 'totalUnitRevenueaffiliates',
        prefix: '$',
        tooltip: [
          'Total revenue in $ on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'New Revenue',
        type: CHART_TYPES.TINY,
        name: 'totalNewRevenueaffiliates',
        prefix: '$',
        tooltip: [
          'New revenue (Hosting cash + Addon cash) in $ on/in <date end>.',
          'The chart and the % shows the trend from <date start> up to and including <date end>.'
        ]
      },
      {
        title: 'Sales Results',
        type: CHART_TYPES.TABLE,
        name: 'netResultsAffiliates',
        fixedNumbers: true,
        tooltip: [
          'Detailed table of the sales results on specific dates (or periods if grouped on week, month or year).',
          'New average hosting cash and New average addon cash is calculated by dividing the New Cash through the New Units.',
          'Total Cash is New Cash + Renewal Cash - Refund Cash.'
        ]
      },
      {
        title: 'Earned Cash',
        type: CHART_TYPES.AREA,
        name: 'earnedCashaffiliates',
        yAxis: 'Amount',
        tooltip:
          'A visual representation of the table above on specific dates (or periods if grouped on week, month or year), showing the New/Rebill Hosting and the New/Rebill Addon amount together with the Refund.',
        prefix: '$'
      },
      {
        title: 'Join Conversion for selected brands',
        type: CHART_TYPES.GRAPH,
        name: 'joinConversionPerBrandaffiliates',
        doubleYAxis: true,
        suffix: '%',
        yAxis: ['Conversion', 'Joins'],
        visible: ['Total Conversion', 'Total Joins', 'ConstantContact Joins', 'ConstantContact Conversion'],
        disableBrands: true,
        tooltip: [
          'A visual representation of the join conversion on specific dates (or periods if grouped on week, month or year).',
          'By default Total Conversion and Total Joins is enabled and shown, and you can (de)select specific brands to compare results on brand level.'
        ]
      },
      {
        title: 'New Hosting units by term',
        type: CHART_TYPES.FIXED,
        name: 'newHostingUnitsTermsaffiliates',
        valueName: 'Units',
        yAxis: 'Percentage',
        tooltip:
          'A visual representation of the percentage of the terms chosen for newly bought plans on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'New subscription units',
        type: CHART_TYPES.GRAPH,
        name: 'newSubscriptionUnitsaffiliates',
        hideSeries: ['All Brands'],
        emptyScreenWhenNoData: true,
        disableBrands: true,
        tooltip:
          'A visual representation of the number of newly bought plans on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'New subscription revenue per day',
        type: CHART_TYPES.GRAPH,
        name: 'newSubscriptionRevenueaffiliates',
        hideSeries: ['All Brands'],
        emptyScreenWhenNoData: true,
        disableBrands: true,
        prefix: '$',
        tooltip:
          'A visual representation of the revenue for newly bought plans on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'New Units for selected plans',
        type: CHART_TYPES.GRAPH,
        name: 'plansNewUnitsaffiliates',
        yAxis: 'Amount per plan',
        tooltip: [
          'A visual representation of the number of newly bought plans per plan type on specific dates (or periods if grouped on week, month or year).',
          'GATOR plans: Starter (PLAN1), Premium (PLAN3), Ecommerce (PLAN4).'
        ]
      },
      {
        title: 'Hosting renewals in plan codes',
        type: CHART_TYPES.GRAPH,
        name: 'rebillPlansaffiliates',
        yAxis: 'Amount per plan',
        tooltip: [
          'A visual representation of the number of renewed plans per plan type on specific dates (or periods if grouped on week, month or year).',
          'GATOR plans: Starter (PLAN1), Premium (PLAN3), Ecommerce (PLAN4).'
        ]
      },
      {
        title: 'New Hosting payment type units',
        type: CHART_TYPES.GRAPH,
        name: 'newHostingPaymentTypeaffiliates',
        yAxis: 'Amount per payment type',
        tooltip:
          'A visual representation of the number of Credit Card and PayPal payments of newly bought plans per plan type on specific dates (or periods if grouped on week, month or year).'
      },
      {
        title: 'Month-to-Date comparison',
        type: CHART_TYPES.TABLE,
        name: 'MonthToDateComparisonaffiliates',
        fixedNumbers: true,
        tooltip:
          'Detailed table of the 6 most important Month-to-Date Financial Stats, compared to that same date range for the 2 previous months and that same date range for exactly 1 year ago.',
        className: 'grid-col-6'
      }
    ],
    sourcedatabase: 'reportinggator',
    route: '/financial-reports/ctct/affiliates',
    disableToday: true,
    fixedPartnerId: 50
  },
  reportingCtctActiveSubscribers: {
    charts: [
      {
        title: 'Active Subscribers',
        name: 'activesubscribers',
        type: CHART_TYPES.TABLE
      },
      {
        title: 'Active Subscribers by plan',
        name: 'ActivesubscribersByPlan',
        type: CHART_TYPES.TABLE
      },
      {
        title: 'Active Subscribers per day',
        name: 'ActiveSubscribersPerDay',
        type: CHART_TYPES.GRAPH
      }
    ],
    route: '/financial-reports/ctct/active-subscribers',
    fixedPartnerId: 50
  },
  reportingCtctV2: {
    charts: [
      {
        title: 'Accounts by package',
        name: 'CTCTNewBuilderAccountsByPackage',
        type: CHART_TYPES.PIE,
        className: 'grid-col-4'
      },
      {
        title: 'Accounts by lander type',
        name: 'CTCTNewBuilderAccountsByLanderType',
        type: CHART_TYPES.PIE,
        className: 'grid-col-4'
      },
      {
        title: 'Accounts by package and status',
        type: CHART_TYPES.STACKED,
        name: 'CTCTNewBuilderAccountsByPackageAndStatus',
        valueName: 'Units',
        className: 'grid-col-4',
        chartType: 'bar',
        tooltipLabel: ''
      },
      {
        title: 'Accounts by usage',
        type: CHART_TYPES.STACKED,
        name: 'CTCTNewBuilderAccountsByUsage',
        valueName: 'Units',
        className: 'grid-col-4',
        chartType: 'bar',
        tooltipLabel: ''
      },
      {
        title: 'All accounts',
        name: 'CTCTNewBuilderAccounts',
        type: CHART_TYPES.TABLE,
        className: 'grid-col-8'
      }
    ],
    route: '/financial-reports/ctct/v2',
    fixedPartnerId: 50
  }
}
